document.addEventListener('DOMContentLoaded', function () { 
  const counters = document.querySelectorAll('.number-counter-value');
  const targetSections = document.querySelectorAll('.inview-initialized');
  
  function onEnterView(target) {
  counters.forEach(function(counter) {
    const maxValue = parseInt(counter.getAttribute('data-value'), 10);    
    let currentValue = parseInt(counter.innerText, 10) || 0;

    const duration = 1500;
    const stepTime = Math.abs(Math.floor(duration / maxValue));

    const incrementCounter = function() {
      currentValue += 1;
      counter.innerText = currentValue.toLocaleString();
      if (currentValue < maxValue) {
        setTimeout(incrementCounter, stepTime);
      } else {
        counter.innerText = maxValue.toLocaleString();
      }
    };
    incrementCounter();
  });
   
  }

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        onEnterView(entry.target);     
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, {
    root: null, 
    rootMargin: '0px',
    threshold: 0.1 
  });
 
  
  targetSections.forEach(targetSection => {
    observer.observe(targetSection);
  });
});


